import { call, select, delay } from 'redux-saga/effects';
import i18n from 'i18next';

import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsToken from '@netsapiens/netsapiens-js/dist/token';
import { selectDevicePostFix } from '../../state/configs/configsSlice';
import store from '../../state/store';
import { setSnackbar } from '../../state/snackbar/snackbarSlice';
import { ERROR } from '../../constants';

export default function* retrieveParked({ payload: parkId }) {
  const decodedToken = yield call(nsToken.getDecoded);
  const devicePostFix = yield select(selectDevicePostFix);
  yield nsApi.get({
    object: 'call',
    action: 'xfer',
    callid: parkId,
    destination: `sip:${decodedToken.user}${devicePostFix}@${decodedToken.domain}`,
    uid: decodedToken.sub,
    domain: decodedToken.domain,
  })
    .then((res) => { console.debug('retrieveParked res:', res); })
    .catch((e) => {
      console.error('retrieveParked error:', e);
      store.dispatch(setSnackbar({
        type: ERROR,
        open: true,
        message: i18n.t('RETRIEVE_PARK_FAILED'),
      }));
    });
  yield delay(500);
}
